export default __webpack_public_path__ + "static/media/AKM_8.543e5c54.png";